import * as React from 'react';
import { Ref, forwardRef } from 'react';
const SvgMap = (_, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    height={_.height}
    width={_.width}
    className={_.className}
    role={_.role}
    aria-label={_.ariaLabel}
    aria-hidden={_.ariaHidden}
    ref={ref}
  >
    <path
      fill={_.color}
      d="M16 1.725a.72.72 0 0 0-.353-.616.77.77 0 0 0-.728-.033l-3.903 1.858-5.391-1.77a1.82 1.82 0 0 0-1.31.069L.432 3A.72.72 0 0 0 0 3.655v10.62c0 .248.131.48.347.613a.77.77 0 0 0 .722.042l3.978-1.807 5.334 1.717c.428.139.89.112 1.3-.075l3.888-1.766a.72.72 0 0 0 .431-.654zM4.5 2.753v9.022l-3 1.363v-9.02zM6 11.904V2.82l4 1.312v9.06zm5.5-7.585 3-1.43v8.997l-3 1.364z"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgMap);
export default ForwardRef;
